import Vue from 'vue';
import Router from 'vue-router';
import routers from './systemRouters.js';
import dialog from '@/components/Dialog';
import store from '../store'; // 引入store
import { getToken, getAppId } from '@/utils';
import { Notification, MessageBox, Message, Loading } from 'element-ui'

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: routers
});

router.beforeEach((to, from, next) => {
  // 在这里调用store的addTag方法，传入需要的参数
  // console.log('beforeEach',to) 
  // store.commit('addTag',{menuId: to.name, formRouterName: to.name, menuName: to.meta.title,path:to.path,query:to.query}); // 假设你需要传递参数id
  next();
});

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(e => { });
}

const originalReplace = Router.prototype.replace;
Router.prototype.replace = function push(location, onComplete, onAbort) {
  return originalReplace.call(this, location, onComplete, onAbort).catch(e => { });
}
// 第三方页面路由跳转映射
const thirdRouteMap = {
  handlerFlowTask: 'thirdHandlerFlowTask'
}
/**
 * 路由跳转的时候判断token是否存在
 */
router.beforeResolve((to, from, next) => {
  if (to.name === 'login') {
    next();
  } else if (to.path.indexOf('/thirdParty/') !== -1) {
    // 第三方接入URL
    next();
  } else {
    let token = getToken();
    if (!token || !/\S/.test(token)) {
      dialog.closeAll();
      next({ name: 'login' })
    } else if (from.path.indexOf('/thirdParty/') !== -1 && thirdRouteMap[to.name]) {
      // 第三方接入跳转页面，需要跳转到第三方的路由上
      let url = location.origin + location.pathname + '#/thirdParty/' + thirdRouteMap[to.name] + '?appId=' + getAppId() + '&token=' + getToken();
      url += ('&thirdParamsString=' + encodeURIComponent(JSON.stringify(to.query)));
      location.href = url
    } else {
      next();
    }
  }
});

router.onError((error) => {
  console.log('message:', error.message);
  console.log('name:', error.name);
  console.log('error:', error);
  if (error.name === 'ChunkLoadError') {
    // 处理 ChunkLoadError 的逻辑  
    // 例如，你可以重定向到一个错误页面  
    Message({
      message: "页面未操作时间过长,请重新登录！",
      type: 'warning'
    })
    router.push('/login');  
    location.reload();
    // this.$confirm("页面未操作时间过长，是否重新加载？, 是否继续?", "提示", {
    //   confirmButtonText: "确定",
    //   cancelButtonText: "取消",
    //   type: "warning",
    // })
    //   .then(() => {
    //     location.reload();
    //   })
    //   .catch(() => {
    //     this.$message({
    //       type: "info",
    //       message: "已取消",
    //     });
    //   });
  }
});

export default router;
